import { useStatistics } from './StatiscticsContext';
import ArrowGrayLeftMore from '@/assets/icons/V3/arrow/ArrowGrayLeftMore.svg?react';
import ArrowGrayRightMore from '@/assets/icons/V3/arrow/ArrowGrayRightMore.svg?react';
import { useMembershipPreviewMode } from '@/components/membership/MembershipContentLock';

const MonthNavigator = () => {
  const { monthlySalesList, activedMonthlySales, setActivedMonthlySales } = useStatistics();
  const isPreviewMode = useMembershipPreviewMode();

  // 현재 선택된 월의 인덱스
  const currentIndex = monthlySalesList.findIndex(
    (item) => item.Month === activedMonthlySales.Month,
  );
  const isPrevDisabled = currentIndex <= 0;
  const isNextDisabled = currentIndex < 0 || currentIndex >= monthlySalesList.length - 1;

  // YYYY-MM → "YYYY년 M월"로 표시
  const getKoreanMonth = (monthStr: string) => {
    const [year, month] = monthStr.split('-');
    return `${year}년 ${Number(month)}월`;
  };

  // 이전/다음 월로 이동
  const moveMonth = (direction: 'prev' | 'next') => {
    if (direction === 'prev' && currentIndex > 0) {
      setActivedMonthlySales(monthlySalesList[currentIndex - 1]);
    }
    if (direction === 'next' && currentIndex < monthlySalesList.length - 1) {
      setActivedMonthlySales(monthlySalesList[currentIndex + 1]);
    }
  };

  if (!activedMonthlySales?.Month) return null;

  return (
    <div
      className="flex items-center gap-2"
      data-membership-preview-interactive={isPreviewMode ? 'true' : undefined}
    >
      <button
        aria-label="이전 달"
        className="flex h-6 w-6 items-center justify-center disabled:opacity-30"
        disabled={isPrevDisabled}
        onClick={() => moveMonth('prev')}
        type="button"
      >
        <ArrowGrayLeftMore />
      </button>
      <span className="text-gr-800 Title3S18">{getKoreanMonth(activedMonthlySales.Month)}</span>
      <button
        aria-label="다음 달"
        className="flex h-6 w-6 items-center justify-center disabled:opacity-30"
        disabled={isNextDisabled}
        onClick={() => moveMonth('next')}
        type="button"
      >
        <ArrowGrayRightMore />
      </button>
    </div>
  );
};

export default MonthNavigator;
